<script setup>
import { computed, provide, ref } from "vue";
import ChargemapSubMenu from "./ChargemapSubMenu.vue";
const props = defineProps({
  listLinks: {
    type: Array,
    required: true
  },
  authorized: {
    type: Boolean,
    default: true
  },
  isBig: {
    type: Boolean,
    default: false
  },
  isSubMenuLink: {
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(["closeMobileMenu"]);
const activeSubMenuId = ref(null);
const linksAuthorized = computed(
  () => props.listLinks.filter(
    (link) => link.authorized === void 0 || link.authorized === true
  )
);
const setActiveSubMenu = (id) => {
  if (!props.isSubMenuLink) {
    activeSubMenuId.value = activeSubMenuId.value === id ? null : id;
  }
};
const handleMainLinkClick = () => {
  if (!props.isSubMenuLink) {
    activeSubMenuId.value = null;
  }
};
provide("subMenuState", {
  activeSubMenuId,
  setActiveSubMenu
});
</script>

<template>
    <div v-if="authorized" class="w-full">
        <div class="flex flex-col gap-1 overflow-hidden">
            <template v-for="link in linksAuthorized">
                <ChargemapMenuLink
                    v-if="!link.linksSubMenu"
                    :key="`${link.id}-${link.title}`"
                    :link
                    :is-sub-menu-link
                    :is-big
                    @click="handleMainLinkClick"
                    @closeMobileMenu="emits('closeMobileMenu')"
                />
                <ChargemapSubMenu
                    v-else
                    :key="`${link.id}-${link.title}-submenu`"
                    :link
                    :is-big
                />
            </template>
        </div>
    </div>
</template>
